import { smsClient } from '../client';
import type { LinkGetUrlQuery, LinkReplacementRequestBody, LinkReplacementsQuery } from '../types';
import { smsGet } from './http';

function toQuery(query: LinkReplacementsQuery, withPaging: boolean): Record<string, string | number | boolean | null | undefined> {
  const base: Record<string, string | number | boolean | null | undefined> = {
    start_date: query.start_date,
    end_date: query.end_date,
    stream_id: query.stream_id ?? null,
    aggregator_id: query.aggregator_id ?? null,
  };
  if (withPaging) {
    base.offset = query.offset ?? 0;
    base.limit = query.limit ?? 1000;
  }
  return base;
}

export async function fetchLinkUrl(query: LinkGetUrlQuery): Promise<unknown> {
  const { data, error } = await smsClient.GET('/link_replacements/get_url/', {
    params: {
      query: {
        host: query.host,
        uri: query.uri,
      },
    },
  });
  if (error) throw error;
  return data;
}

export async function fetchLinkUrlPost(body: LinkReplacementRequestBody): Promise<unknown> {
  const { data, error } = await smsClient.POST('/link_replacements/get_url/', { body });
  if (error) throw error;
  return data;
}

/** GET /link_replacements/ */
export async function fetchLinkReplacements(query: LinkReplacementsQuery): Promise<unknown> {
  return smsGet<unknown>('/link_replacements/', toQuery(query, true));
}

/** GET /link_replacements/stats/ */
export async function fetchLinkStats(query: LinkReplacementsQuery): Promise<unknown> {
  return smsGet<unknown>('/link_replacements/stats/', toQuery(query, false));
}

/** GET /link_replacements/clicks/ */
export async function fetchLinkClicks(query: LinkReplacementsQuery): Promise<unknown> {
  return smsGet<unknown>('/link_replacements/clicks/', toQuery(query, true));
}
